import React from "react";

import Modal from "../general/Modal"
import RegistrationCardForm from '../../features/common/RegistrationCardForm'

const RegistrationCardFormModal = ({ show, onClose }) => {
    return (
        <Modal show={show} containerClasses="!bg-[#292929] rounded" onClose={onClose} styles="max-w-[30%]" transition="animateup">
            <RegistrationCardForm name="Unknown (From Registration Card)" />
        </Modal>
    )
}

export default RegistrationCardFormModal;